function initialState() {
  return {
    genres: [],
    isLoaded: false,
    isLoading: false,
  }
}

let state = initialState()

export { initialState, state }
